import getTelemetryUserData from './getTelemetryUserData';
import {
  SubscriptionType,
  SubscriptionStatus,
  SubscriptionTier,
  SubscriptionDuration,
  emsSubStatusMap,
} from './subscriptionConstants';

const STATUS_SUBSCRIPTIONS = [
  [SubscriptionType.GTA_PLUS, 'gtaPlusSubscription'],
  [SubscriptionType.UBISOFT_PLUS, 'ubisoftPlusSubscription'],
];

const getEmsSubscriptionStatus = subscriptionData => (
  emsSubStatusMap[subscriptionData?.substring(0, subscriptionData.indexOf('_'))]
  || SubscriptionStatus.NEVER
);

const getSubscriptionState = (userData = {}) => {
  const { emsCriteria } = userData;

  if (!emsCriteria) return undefined;

  const subscriptionState = [
    { subscriptionType: SubscriptionType.PSNOW, subscriptionData: emsCriteria.psNow },
    { subscriptionType: SubscriptionType.EAACCESS, subscriptionData: emsCriteria.eaAccess },
  ].map(({ subscriptionType, subscriptionData }) => ({
    subscriptionType,
    subscriptionStatus: getEmsSubscriptionStatus(subscriptionData),
  }));

  STATUS_SUBSCRIPTIONS.forEach(([subscriptionType, field]) => {
    subscriptionState.push({
      subscriptionType,
      subscriptionStatus: userData[field]?.status || SubscriptionStatus.NEVER,
    });
  });

  const { psPlusSubscription, loyaltySubscription } = userData;

  subscriptionState.push({
    subscriptionType: SubscriptionType.PSPLUS,
    subscriptionStatus: psPlusSubscription?.status || SubscriptionStatus.NEVER,
    subscriptionTier: psPlusSubscription?.psPlusTier || SubscriptionTier.NONE,
    subscriptionDuration: psPlusSubscription?.duration || SubscriptionDuration.NONE,
    ...(psPlusSubscription?.flag && { subscriptionFlag: psPlusSubscription.flag }),
  });

  subscriptionState.push({
    subscriptionType: SubscriptionType.LOYALTY,
    subscriptionStatus: loyaltySubscription?.enrollStatus || SubscriptionStatus.NOT_ENROLLED,
    subscriptionTier: loyaltySubscription?.statusLevel || SubscriptionTier.NO_LOYALTY_LEVEL,
  });

  return subscriptionState;
};

export const resolveSignedInStatus = (userData = {}) => {
  const opts = window.sharedNav?.opts || {};

  if (typeof opts.getSignedInStatus === 'function') {
    return !!opts.getSignedInStatus();
  }

  if (typeof userData.isLoggedIn === 'boolean') {
    return userData.isLoggedIn;
  }

  if (typeof window.psnWebToolbar?.isSignedIn === 'function') {
    return window.psnWebToolbar.isSignedIn();
  }

  return false;
};

export const buildUserTelemetryFields = (userData, isSignedIn) => {
  const fields = {
    loggedIn: isSignedIn,
    signedIn: isSignedIn,
    psnAccountId: isSignedIn ? (userData.accountId || '') : '',
    psnAccountLanguage: isSignedIn ? (userData.accountLanguage || '') : '',
    psnAccountRegion: isSignedIn ? (userData.accountRegion || '') : '',
  };

  if (isSignedIn) {
    if (userData.hashedAccountId) {
      fields.hashedPsnAccountId = userData.hashedAccountId;
    }

    const subscriptionState = getSubscriptionState(userData);
    if (subscriptionState) fields.subscriptionState = subscriptionState;
  }

  return fields;
};

/**
 * Builds fresh user/global telemetry fields for each event dispatch.
 * Host apps can provide live session data via window.sharedNav.opts.getTelemetryUserData.
 */
export default () => {
  const userData = getTelemetryUserData();
  const isSignedIn = resolveSignedInStatus(userData);

  return {
    ...buildUserTelemetryFields(userData, isSignedIn),
    pageURL: window.location?.href,
    referrerURL: document.referrer,
  };
};
